/**
 * region for libraries*/
 import React, { Component } from "react";
 import PropTypes from "prop-types";
 import clsx from "clsx";
 import { withStyles } from "@material-ui/core/styles";
 import { AppBar, Drawer } from "@material-ui/core";
 
 import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
 
 /**
  * region for styles*/
 import { layoutCompaniesWithoutKeyContactsStyle } from "./style/layoutCompaniesWithoutKeyContactsStyle";
 
 /**
  * region for containers*/
 import HeaderCompaniesWithoutKeyContacts from "../../../containers/companies/HeaderCompaniesWithoutKeyContacts";
 
 import ReportCompaniesWithoutKeyContacts from "../../../containers/companies/ReportCompaniesWithoutKeyContacts";
 
 /**
  * region for hepers*/
 
 /**
  * region for constans*/
 
 class LayoutCompaniesWithoutKeyContacts extends Component {
   state = {
     showMenu: false, //permanet disabled
   };
 
   
 
   render() {
     const { classes } = this.props;
     const { showMenu } = this.state;
     return (
       <Router>
         <div className={classes.root}>
           <AppBar className={clsx(classes.appBar)} position="absolute" color="inherit" elevation={0}>
             <HeaderCompaniesWithoutKeyContacts />
           </AppBar>
           {showMenu && <Drawer classes={{ paper: clsx(classes.drawerPaper) }} open={true} variant="permanent"></Drawer>}
           <div className={classes.content}>
             <div className={classes.appBarSpacer} />
             <Switch>
               <Route exact path="/LayoutCompaniesWithoutKeyContacts">
                 <ReportCompaniesWithoutKeyContacts />
               </Route>
             </Switch>
           </div>
         </div>
       </Router>
     );
   }
 }
 LayoutCompaniesWithoutKeyContacts.propTypes = {
   classes: PropTypes.object.isRequired,
 };
 export default withStyles(layoutCompaniesWithoutKeyContactsStyle)(LayoutCompaniesWithoutKeyContacts);